
/**
*
* Фреймворк для генерации инлайн-форм. 
*
* @version 0.0.1
* @author Igor Kuzmin (aka Odeann)
*
*/
/***/

(function($){

	// расширим класс jQuery до возожности создавать текстовые поля ограничивающие ввод только до цифр.
	$.fn.numberInput = function() {
		return this.each(function() {
			$(this).keydown(function(event){
				return KEYS_ALLOWED[event.keyCode] ? true : false;
			});
		});
	};
	var KEYS_ALLOWED = {
		   8 : 'BACKSPACE'
		,  9 : 'TAB'
		, 17 : 'CTRL'
		, 13 : 'ENTER'
		, 37 : 'LEFT_ARROW'
		, 39 : 'RIGHT_ARROW'
		, 46 : 'DELETE'
		, 48 : 'ZERO'
		, 49 : 'ONE'
		, 50 : 'TWO'
		, 51 : 'THREE'
		, 52 : 'FOUR'
		, 53 : 'FIVE'
		, 54 : 'SIX'
		, 55 : 'SEVEN'
		, 56 : 'EIGHT'
		, 57 : 'NINE'
	};

	$.fn.moneyInput = function() {
		return this.each(function() {
			$(this).keydown(function(event){
			   //	alert(event.keyCode);
				return KEYS_ALLOWED_4_MONEY[event.keyCode] ? true : false;
			});
		});
	};
	var KEYS_ALLOWED_4_MONEY = {
		   8 : 'BACKSPACE'
		,  9 : 'TAB'
		, 17 : 'CTRL'
		, 13 : 'ENTER'
		, 37 : 'LEFT_ARROW'
		, 39 : 'RIGHT_ARROW'
		, 46 : 'DELETE'
		, 48 : 'ZERO'
		, 49 : 'ONE'
		, 50 : 'TWO'
		, 51 : 'THREE'
		, 52 : 'FOUR'
		, 53 : 'FIVE'
		, 54 : 'SIX'
		, 55 : 'SEVEN'
		, 56 : 'EIGHT'
		, 57 : 'NINE'
		, 188 : ','
		, 189 : ','
		, 190 : '.'
		, 191 : '.'
	};



	$.fn.inlinedit = function(options)
	{
	
		// options.name — имя параметра. Будет также использовано при отправке на сохранение как имя переменной.
		// необязательный: storefunc — функция, которая заменит функцию сохранения.

		var defaults =
		{
	        format		: '', //указывается формат для jquery.maskedinput.js. Указывается только в случае, если tp = "other";
	        length		: 0, // длина поля. В случае, если length = 0 — ограничения нет. .
	        url			: '', // адрес для сохранения.
	        method		: 'POST', 
	        datatype	: 'json',
	        params		: '',
			callback	: function(){}
		};

		if(options == undefined) var options = {};
		if(options.tp == undefined) options.tp = 'string'; // ["int", "date", "html",  "text",  "string", "other".
		if((options.tp == "text")||(options.tp == "html"))
		{
			defaults.width = "100%"; //ширина поля для редактирования.
			defaults.height = '360', // высота поля. В пикселях. (т.е. размерность не указывать)

			defaults.method = 'POST'; //  метод, которым отправляютс яна сохранение данные.
		}
		else
		{
			defaults.width = "280px"; //ширина поля для редактирования.
			defaults.method = 'GET'; //  метод, которым отправляютс яна сохранение данные.
		};
		
		options = jQuery.extend(defaults, options);

		new jQuery.powerform.INPUT(this, options);
		
		return this;

	
	};
	

	/**
	*
	* Класс для создания редактируемых inline-форм
	*
	*/
	jQuery.powerform = {};
	jQuery.powerform.forms = {};
	jQuery.powerform.currform = {};
	jQuery.powerform.currelement = {};

    jQuery.powerform.enviroment = {};
	jQuery.powerform.enviroment.is_inited = 0;

	jQuery.powerform.enviroment.init = function()
	{
        if(!jQuery.powerform.enviroment.is_inited)
        {

            /***
			var talign = $(this).css("text-align");
			var stralign = "";
			if(talign=="right") stralign= "align=\"right\"";
			else if(talign=="center") stralign="style=\"margin-left: auto!important; margin-right: auto!important;\"";
			var $obj = $(this).wrapInner("<table class=\"inline-external-table\" "+stralign+" border='0' cellspacing='0' sellpadding='0'><tr><td></td></table>").find("td");
            /****/

			//alert(jQuery.powerform.enviroment.is_inited);
			$("#pie_back").click(function(){jQuery.powerform.currform.close();});
			jQuery.powerform.enviroment.is_inited = 1;
			$("#pie_input").keyup(function()
			{
                //alert("pressed!");
				$(jQuery.powerform.currelement).text($("#pie_input").val());
				jQuery.powerform.currform.dimset();
			}).keydown(function(event)
			{
                if(event.keyCode == 13)
				{
					return false;
				}
				else return true;
			});
		}
	};

	jQuery.powerform.INPUT = function(element, options)
	{

		this.element	= element;
		this.name		= options.name; // имя параметра
		this.tp			= options.tp; // [необязательный] "int", "date", "html",  "text",  "string", "other". Если указано число, то это число — текстовое поле (tp="string") с максимальным кол-вом символов (length) = введенному числу. Если параметр не указан, то берется "string" БЕЗ ограничения по кол-ву символов.
		this.length		= options.length; // [необязательный] длина поля. В случае, если length = 0 — ограничения нет. 
		this.height		= options.height; // [няобязательный] высота в пикселях — т.е. без размерности.
		this.width		= options.width; // [няобязательный] ширина поля для записи в css (т.е. передавать надо прямо с размерностью, e.g: 100%, 235px, 40em).
		this.format		= options.format; // [необязательный] указывается формат для jquery.maskedinput.js. Указывается только в случае, если tp = "other";
		this.url		= options.url; // [необязательный] url, по которому отправляются данные для проверки.
		this.storefunc	= options.storefunc; // [необязательный] перегрузка функции для сохранения данных.
		this.params		= options.optionss; // [необязательный] параметры, которые надо отправить дополнительно.
		this.method		= options.method; // [необязательный] GET | POST. По умолчанию: POST
		this.datatype	= options.datatype; // [необязательный] формат получаемых данных: json, xml .. По умолчанию json;
		this.callback	= options.callback;
		
		
		//this = jQuery.extend(this, options);

		return this.setform();

				
	}; // end of jQuery.powerform.INPUT




	// генерируется только 1 раз и в случае если форма ещё не открывалась
	jQuery.powerform.INPUT.prototype.setform = function()
	{



		var input = this;
		var element = this.element;

		jQuery.powerform.enviroment.init();

		if(!$(element).find(".editable").length)
		{
			$(element).unbind('dblclick').dblclick(function()
			{
				input.generate_input(); // сгенерируем слой с самой формочкой.
				//input.edit(); // назначает на событие двойного клика открытие формы для редактирования.
			});
			return this;
		}
		else
		{
			delete this;
			return false;
		}

	}

	/**
	*
	* 
	*
	*
	*/

	jQuery.powerform.INPUT.prototype.generate_input = function()
	{

		var input = this;
		var element = this.element;
		var length = this.length;
		var height = this.height;
		var name = this.name;
		//var minWidth = this.width;

		if($(element).find(".pie_opened").length == 0)
		{
			/***/
			var talign = $(element).css("text-align");
			var stralign = "";
			if(talign=="right") stralign= "align=\"right\"";
			else if(talign=="center") stralign="style=\"margin-left: auto!important; margin-right: auto!important;\"";

			this.element =
				$(element)
					.wrapInner("<table class=\"inline-external-table\" "+stralign+" border='0' cellspacing='0' sellpadding='0'><tr><td><span class=\"pie_opened\"></span></td></table>")
					.find("td");
			element = this.element;
            /****/
			//	$(element).wrapInner("");
		}
		element = $(element).find(".pie_opened");

        this.dimset();


		function get_ReallCSS(element, propname)
		{
			var prop;
			var el = element;
			for(prop = ""; el&&((prop == "transparent")||(prop == "none")||(prop == "inherit")||(prop == "")||(prop == "rgba(0, 0, 0, 0)")); el = $(el).parent())
			{
				prop = $(el).css(propname);
			}
			//alert(prop);
			return prop;
		}
		var bgcolor =  get_ReallCSS(element,"background-color");

        var css = {};
        css.backgroundColor = bgcolor;
		css.color = $(element).css("color");
		css.fontSize = $(element).css("font-size");
		css.fontFamily = $(element).css("font-family");
		css.fontStyle = $(element).css("font-style");
		css.fontVariant = $(element).css("font-variant");
		css.fontWeight = $(element).css("font-weight");
		css.direction = $(element).css("direction");
		css.letterSpacing = $(element).css("letter-spacing");
		css.textAlign = $(element).css("text-align");
		css.textDecoration = $(element).css("text-decoration");
		css.textTransform = $(element).css("text-transform");
		css.textIndent = $(element).css("text-indent");
		css.unicodeBidi = $(element).css("unicode-bidi");
		css.verticalAlign = $(element).css("vertical-align");
		css.whiteSpace = $(element).css("white-space");
		css.lineHeight = $(element).css("line-height");
		css.wordSpacing = $(element).css("word-spacing");
		//alert(name+"|"+length+"|"+width);

		// учтем line-height
		//var lheight = $(element).css("line-height");
		//if(lheight)


		$("#pie_input").val($(element).text());
        $("#pie_place").css(css);

		// Учтем выравнивание:
		//$("#pie_place").find("textarea").css("text-align", $(element).css("text-align"));

		jQuery.powerform.currform = this; // обязательно до того, как покажем, а то вдруг пользователь успеет кликнуть сразу после показа по фону, еще до выполнения этой строчки.
        jQuery.powerform.currelement = element;

		$(".pie_blocks").show();



	}; // end of jQuery.powerform.INPUT.prototype.generate_input


	jQuery.powerform.INPUT.prototype.dimset = function()
	{

  		var element = this.element;
		var input = this;
		var length = this.length;
		var height = this.height;
		var name = this.name;

		var offset	= $(element).offset();
		var width	= $(element).width();

        var align = $(element).css("text-align");
		//if(align == "center") offset.left -= width/2;

        var css_place = {};
		var css_shadow = {};
		var css_button = {};

		//if(minWidth) css_place.minWidth = minWidth;
		if(height) css_place.height = height;
		else css_place.height	= $(element).height();
		css_place.width = width+20;
		css_place.marginLeft = offset.left - 4;
		css_place.marginTop = offset.top;

		//if(minWidth) css_shadow.minWidth = minWidth;
		if(height) css_shadow.height = height;
		else css_shadow.height	= $(element).height();
		css_shadow.width = width+80;
		css_shadow.marginLeft = offset.left - 6;
		css_shadow.marginTop = offset.top - 2;

		if(height) css_button.height = height;
		else css_button.height	= $(element).height();
		css_button.width = 52;
		css_button.marginLeft = offset.left + width + 24;
		css_button.marginTop = offset.top;

		if(align == "center")
		{
	        css_place.marginLeft  -= 10;
			css_shadow.marginLeft -= 10;
			css_button.marginLeft -= 10;
		}
		else if(align == "right")
		{
	        css_place.marginLeft  -= 20;
			css_shadow.marginLeft -= 20;
			css_button.marginLeft -= 20;
		}

        $("#pie_shadow").css(css_shadow);
        $("#pie_button").css(css_button);
        $("#pie_place").css(css_place);


	}; // end of jQuery.powerform.INPUT.prototype.store

	jQuery.powerform.INPUT.prototype.store = function()
	{

  		var element = this.element;
		var input = this;


	}; // end of jQuery.powerform.INPUT.prototype.store

	jQuery.powerform.INPUT.prototype.close = function()
	{

		var element = this.element;
		$(".pie_blocks").hide();

	}; // end of jQuery.powerform.INPUT.prototype.cancel


	jQuery.powerform.INPUT.prototype.focus = function()
	{


	}; // end of jQuery.powerform.INPUT.prototype.focus




})(jQuery);


/***/







